import AppDBStorage from '@Services/AppDBStorage';

class BatchExecutionDetailsStorage {
  constructor(ns) {
    this._ns = ns;
    this._instance = null;
  }

  getInstance() {
    if (!this._instance) {
      this._instance = new AppDBStorage(this._ns);
    }

    return this._instance;
  }
}

export const namespace = 'BatchExecutionDetails_';
export default new BatchExecutionDetailsStorage(namespace);
